import React from 'react'
import PropTypes from 'prop-types'

const LiLink = ({ href, className, children }) => (
  <li className={className}>
    <a href={`https://labelinsight.com${href}`}>{children}</a>
  </li>
)

LiLink.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
}

export default LiLink



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/Header/LiLink.js